import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './checkbox.scss';
import SvgIcon from '../svg-icon/svg-icon';

const Checkbox = ({ data, callback, disabled }) => {
    const theData = data || { type: 'plain', selected: true };
    const theCallback = callback || function dummy() {};
    const type = theData.type;
    const selected = theData.selected;
    const tick = selected ? (<SvgIcon type={`${type}-checkbox-tick`} />) : (<SvgIcon type="null-checkbox-tick" />);
    const selectedClass = selected ? 'selected' : 'not-selected';
    const checkboxClass = `${css.checkbox} ${css[type]} ${css[selectedClass]} ${disabled ? css.disabled : ''}`;
    const label = typeof theData.label !== 'undefined' ?
        (
            <div className={css.label}>
                {theData.label}
            </div>
        ) : '';
    return (
        <div className={checkboxClass}>
            <div
                role="button"
                tabIndex={-1}
                className={css['check-button']}
                onClick={() => theCallback(theData)}
                disabled={disabled}>
                {tick}
            </div>
            {label}
        </div>
    );
};

Checkbox.propTypes = {
    data: PropTypes.object,
    callback: PropTypes.func,
    disabled: PropTypes.bool
};

export default styleable(css)(Checkbox);



// WEBPACK FOOTER //
// ./components/checkbox/checkbox.js